// Zentrale Backend-Konfiguration.
// Die Seite ist als reines Frontend deploybar (Solarrechner rechnet clientseitig).
// Kontaktformular und Chat nutzen das Backend nur, wenn REACT_APP_BACKEND_URL gesetzt ist.

const raw = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const hasBackend = raw.length > 0;
export const API = hasBackend ? `${raw}/api` : "";

export const CONTACT_EMAIL = "hallo@sonnenwerk.ch";
export const CONTACT_PHONE = "+41 44 555 12 34";
export const CONTACT_PHONE_HREF = "tel:+41445551234";

/** Baut einen mailto-Link als Fallback, wenn kein Backend erreichbar ist. */
export function buildMailto({ name, email, phone, topic, message }) {
  const subject = `Anfrage: ${topic || "Allgemeine Anfrage"}`;
  const body = [
    `Name: ${name || "–"}`,
    `E-Mail: ${email || "–"}`,
    `Telefon: ${phone || "–"}`,
    `Thema: ${topic || "–"}`,
    "",
    message || "",
  ].join("\n");
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
}
